import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">SingleG</option><option value=\"1\">WattMin</option><option value=\"2\">GWattMin</option><option value=\"3\">GWattMinVariant</option><option value=\"4\">GTripleWattMin</option><option value=\"5\">GWattMinM3</option>", 6)
const _hoisted_18 = [
  _hoisted_12
]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "col-3" }
const _hoisted_23 = { class: "d-block" }
const _hoisted_24 = { class: "col-3" }
const _hoisted_25 = { class: "d-block" }
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "d-block" }
const _hoisted_28 = { class: "col-3" }
const _hoisted_29 = { class: "d-block" }
const _hoisted_30 = { class: "col-6 d-flex" }
const _hoisted_31 = { class: "d-block" }
const _hoisted_32 = { class: "col-3" }
const _hoisted_33 = { class: "d-block" }
const _hoisted_34 = { class: "text-center mt-5" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Configuration",
          text: "Edit Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOptionalDetailedProcess = false))
              }, "NO OPTIONAL"),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOptionalDetailedProcess = true))
              }, "SI OPTIONAL")
            ])
          ]),
          (_ctx.isOptionalDetailedProcess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.optionalDetailedProcessType) = $event))
                }, _hoisted_18, 512), [
                  [_vModelSelect, _ctx.optionalDetailedProcessType]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Name",
              labelValue: "Name",
              placeholderKey: "Name",
              placeholderValue: "Name",
              modelValue: _ctx.localModel.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Production Group",
              labelValue: "Production Group",
              placeholderKey: "Production Group",
              placeholderValue: "Production Group",
              modelValue: _ctx.localModel.productionGroup,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.productionGroup) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Production Phase",
              labelValue: "Production Phase",
              placeholderKey: "Production Phase",
              placeholderValue: "Production Phase",
              list: _ctx.productionPhases,
              modelValue: _ctx.localModel.productionPhase.identifier,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localModel.productionPhase.identifier) = $event))
            }, null, 8, ["list", "modelValue"]),
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Emission Factor",
              labelValue: "Emission Factor",
              placeholderKey: "Emission Factor",
              placeholderValue: "Emission Factor",
              modelValue: _ctx.localModel.emissionFactor,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localModel.emissionFactor) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.localModel.isUnitCalculated = !_ctx.localModel.isUnitCalculated))
            }, [
              _createElementVNode("label", _hoisted_23, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Calculated in units",
                  text: "Calculated in units"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.isUnitCalculated}])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.localModel.isMandatory = !_ctx.localModel.isMandatory))
            }, [
              _createElementVNode("label", _hoisted_25, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Mandatory",
                  text: "Mandatory"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.isMandatory}])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.localModel.rawMaterialIndipendent = !_ctx.localModel.rawMaterialIndipendent))
            }, [
              _createElementVNode("label", _hoisted_27, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Raw Material Indipendent",
                  text: "Raw Material Indipendent"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.rawMaterialIndipendent}])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.localModel.isElectricityEmissionIndipendent = !_ctx.localModel.isElectricityEmissionIndipendent))
            }, [
              _createElementVNode("label", _hoisted_29, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Electricity Emissions Indipendent",
                  text: "Electricity Emissions Indipendent"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.isElectricityEmissionIndipendent}])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              class: "form-group pointer w-50 ms-2",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.localModel.isUnique = !_ctx.localModel.isUnique))
            }, [
              _createElementVNode("label", _hoisted_31, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Is unique",
                  text: "Is unique"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.isUnique}])
              }, null, 2)
            ]),
            (_ctx.localModel.isUnique)
              ? (_openBlock(), _createBlock(_component_form_field, {
                  key: 0,
                  type: "text",
                  labelKey: "Unique key",
                  labelValue: "Unique key",
                  placeholderKey: "Unique key",
                  placeholderValue: "Unique key",
                  modelValue: _ctx.localModel.uniqueKey,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localModel.uniqueKey) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.localModel.hasCustomAmount = !_ctx.localModel.hasCustomAmount))
            }, [
              _createElementVNode("label", _hoisted_33, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Custom value to specify?",
                  text: "Custom value to specify?"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.hasCustomAmount}])
              }, null, 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "Create",
                text: "Create"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Edit",
                text: "Edit"
              }))
        ], 8, _hoisted_35)
      ])
    ])
  ]))
}